import React, {Component} from 'react';
import ReactToPrint from 'react-to-print';
import DateRangeFilter from '../components/DateRangeFilter';
import DetailedSalesAndSummaryReportSet from '../components/DetailedSalesAndSummaryReportSet';
import LocationFilter from '../components/LocationFilter';
import ReportHeaderLocation from '../components/ReportHeaderLocation';
import NoAccess from '../noAccess';
import {getTimeZoneOffsetDefault} from '../shared/dateTimeLists';
import {hasReportsAccess} from '../shared/authFunctions';
import FuseTheme from '../global/theme';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/receipt';

export const fuseDetailedSalesReportsIcon = Icon;

const styles = {
    button: {color: FuseTheme.palette.primary3Color},
};

/**
 * Detailed Sales Reports class for retrieving and displaying Detailed Sales Summary
 *
 */
export class DetailedSalesReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        const offsetDefault = getTimeZoneOffsetDefault();
        this.state = {
            location: {
                id: null,
                name: '',
                city: '',
                state: ''
            },
            locationsList: [],
            selectedEndDate: null,
            selectedOffset: offsetDefault,
            selectedStartDate: null,
            summaryComplete: false,
            system: system
        };
    }

    /**
     * Convert Dates to visual display
     *
     * @param selectedStartDate
     * @param selectedEndDate
     * @return {string}
     */
    displaySelectedDates(selectedStartDate, selectedEndDate) {
        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        let startDate = new Date(selectedStartDate + 'T00:00:00');
        let endDate = new Date(selectedEndDate + 'T00:00:00');
        let startDateStr = startDate.toLocaleDateString('en-US', options);
        let endDateStr = endDate.toLocaleDateString('en-US', options);

        return (
            'Date Range: ' + startDateStr + ' through ' + endDateStr
        )
    }

    /**
     * Store Locations sent by Location Filter
     *
     * @param list
     */
    setLocationList = (list) => {
        this.setState({
            locationsList: list
        });
    };

    /**
     * Handle selection event for Location
     *
     * @param event
     * @param index
     * @param value
     */
    handleLocationSelect = (event, index, value) => {
        if (index && index !== value) {
            // Extract the full Location object from the selected location_id
            const locationObj = this.state.locationsList.find(r => r.id.toString() === index.id.toString());
            if (locationObj) {
                this.setState({
                    location: {
                        id: locationObj.id,
                        name: locationObj.name,
                        city: locationObj.city,
                        state: locationObj.state
                    },
                });
            }
        }
    };

    /**
     * Handle event props from DateRangeFilter
     *
     * @param type
     * @param value
     */
    handleDateRangeFilterSelect = (type, value) => {
        switch (type) {
            case 'start_date':
                // Set Start Date selection for reports summary component
                this.setState({selectedStartDate: value, summariesComplete: false});
                break;
            case 'end_date':
                // Set End selection for reports summary component
                this.setState({selectedEndDate: value, summariesComplete: false});
                break;
            case 'offset':
                // Set Time Zone Offset selection for reports summary component
                this.setState({selectedOffset: value, summariesComplete: false});
                break;
            default:
                return
        }
    };

    render() {
        const {
            location,
            selectedEndDate,
            selectedStartDate,
            selectedOffset,
            system
        } = this.state;

        if (!hasReportsAccess()) return <NoAccess/>;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Detailed Sales Reports</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>A Detailed Sales Report displays sales totals of all payments for a specific Location
                        for a specified date range. The Report lists totals of gross sales by payment type, and
                        a table of total Products sold.</p>
                    <p>Select a Location, Date Range, and Time Zone Offset to generate a Report. Please note that
                        a date range greater than a month may require time to assemble:</p>
                </span>
            );
        };

        return (
            <div className="lists-container" ref={e => (this.printReportRef = e)}>
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Report Filters (Location, Start Date, End Date, Time Zone) */}
                        <LocationFilter
                            label="Select a Location:"
                            onLocationsLoaded={this.setLocationList}
                            onSelectLocation={this.handleLocationSelect}
                            selectionType="object"
                        />
                        <DateRangeFilter
                            onSelectStartDate={this.handleDateRangeFilterSelect}
                            onSelectEndDate={this.handleDateRangeFilterSelect}
                            onSelectOffset={this.handleDateRangeFilterSelect}
                        />

                        {/* Print Header */}
                        {location &&
                            <ReportHeaderLocation
                                location={location}
                                reportType="Detailed Sales Summary"
                            />
                        }

                        {/* Detailed Sales Report Content */}
                        {location.id && selectedStartDate && selectedEndDate && selectedOffset &&
                            <div>

                                {/* Detailed Sales Report Header, Loader, and messaging */}
                                <div className="report-header">
                                    <div className="btn-print-container report-header-button-container">
                                        <ReactToPrint
                                            trigger={() =>
                                                <RaisedButton
                                                    primary
                                                    type="button"
                                                    label="Print Report"
                                                    style={styles.button}
                                                />
                                            }
                                            content={() => this.printReportRef}
                                        />
                                    </div>
                                    <h2 className="report-header-title">Detailed Sales Report</h2>
                                    <p>
                                        {this.displaySelectedDates(selectedStartDate, selectedEndDate)}
                                    </p>
                                    <p>
                                        Store: {location.id} -{location.name} - {location.city}, {location.state}
                                    </p>
                                </div>

                                {/* Detailed Summary Report */}

                                <DetailedSalesAndSummaryReportSet
                                    location={location}
                                    startDate={selectedStartDate}
                                    endDate={selectedEndDate}
                                    offset={selectedOffset}
                                    system={system}
                                />
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/DetailedSalesReports.js